import React from "react";
import styled from 'styled-components';
import logo from "./../images/logo-wasap.png";
import logoF from "./../images/facebook1.jpg";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './react-leaflet.css';
import {MarkerIcon} from './react-leaflet-icon';


const Contacto = () => {

    const currentLocation= { lat:-35.961882934693875, lng:-62.7422107122449};
    const zoom= 40;
    
      
    return ( 
        <ContenedorContacto>
           
            <MainContacto>
                 <h3>Nuestro local se encuentra en</h3>
                 <p>Wilde 483 - Trenque Laquen</p>
                 <Parrafo></Parrafo>
                 <h3>Horarios de Atención</h3>
                 <p>Lunes a Viernes de 8:30hs a 12hs y de 16hs a 19:30hs </p> 
                 <p>Sábados de 8:30hs a 12hs  </p> 
                 <Parrafo></Parrafo>
                 <h3>Por Mail</h3>
                 <p>eletronicaHertz@gmail.com</p>
                 <Parrafo></Parrafo>
                 <h3>Por Telefono o Whatsapp</h3>
                 <a href="https://wa.me/2392528935/?text=tu%20texto%20personalizado" target="_blank">
                <img src={logo} width="30" height="30"></img> 02392-528935 
                </a>
                <Parrafo></Parrafo>
                <h3>Nuestro Facebook</h3>
                <a href="https://www.facebook.com/profile.php?id=100021155876100" target="_blank">
                <img src={logoF} width="30" height="30"></img>eletronicaHertz</a>
            </MainContacto>
             <aside>
                  <MapContainer center={currentLocation} zoom={zoom}>
                  <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="© <a href='https://osm.org/copyright'>OpenStreetMap</a> contributors"/>
                        <Marker position={currentLocation} icon={MarkerIcon} >
                            <Popup>Electronica HERTZ! </Popup>
                        </Marker>
                </MapContainer>
             </aside>
        </ContenedorContacto>

     );
}
 
const ContenedorContacto= styled.div`
    max-width: 2000px;
    padding: 10px;
    width: 90%;
    display: grid;
    gap: 20px;
    grid-template-columns: 2fr 1fr;
    background: #fff;
    margin: 10px 0;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(129, 129, 129, 0.1);
`;
const MainContacto=styled.main`
    margin-top:10px;
`;
const Parrafo= styled.p`
    padding:10px;
    margin-bottom:10px;
`;
export default Contacto;
